<ng-container>
  <div class="cs-nav-drop-down-overlay" (click)="closeDropDown()" *ngIf="displayUserDropDown"></div>
  <p class="account m-0 d-flex" (click)="openDropDown()">
    <span class="my-auto">Project Office</span>
    <span class="cs-avatar mr-2 ml-3 my-auto">
      <img [src]="propertyLogo ? ( propertyLogo | splitUrl): '/assets/images/cc.png'" class="cs-avatar" alt="" />
    </span>
  </p>
  <div class="cs-nav-drop-down" *ngIf="displayUserDropDown" (click)="closeDropDown()" [@navDropDown]>
    <div class="profile-name">
      <img [src]="userInfo?.avatar? (userInfo?.avatar | splitUrl) : 'assets/images/user.png'"
        class="property-profile-img" />
      <div class="user-details text-ellipse">
        <p class="name text-ellipse">{{userInfo?.profileName}}</p>
        <p class="email text-ellipse">{{userInfo?.email}}</p>
      </div>
    </div>
    <button class="log-out" id="nav_profile_btn_logout" (click)="logout()">
      <span>Log out</span>
    </button>
  </div>
</ng-container>
